module.exports = __webpack_public_path__ + "media/interview_greeting.a7dc665c.mp3";